module.exports = __webpack_public_path__ + "static/img/5.e8eb475.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/5.png
// module id = E5Mm
// module chunks = 0